import React from 'react';
import { criarAgentesRecebedoresDs } from '../DataSources';
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label
} from 'devextreme-react/form';
import UserInfo from "../UserInfo";
import { Popup } from 'devextreme-react/popup';
import { ButtonItem } from "devextreme-react/tree-list";

const _novoImovelInativoTemplate = {
    "id": undefined,
    "dataPagamento": undefined,
    "dataDeposito": undefined,
    "dataInicial": undefined,
    "dataFinal": undefined,
    "agenteRecebedor": undefined,
    "modelo": undefined,
};


export default class ImoveisInativosPopup extends React.Component {
    constructor(props) {
        super(props);
        console.log(this);
        //this.arrecadacaoDs = criarArrecadacaoDs();
        //console.log(this.arrecadacaoDs);
        //console.log(this.arrecadacaoDs.byKey);
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        //this.saidaProgramada = false;
        _novoImovelInativoTemplate.prefeituraId = UserInfo.getPrefeitura();
        this.state = this.props.match.params.id == undefined
            ? _novoImovelInativoTemplate
            : {};

        this.agenteRecebedorOptions = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "Escolher...",
            dataSource: criarAgentesRecebedoresDs(),
            valueExpr: "id",
            displayExpr: "descricao"
        }

        let modelos = [
            { id: 1, descricao: "Modelo 1" },
            { id: 2, descricao: "Modelo 2" },
            { id: 3, descricao: "Modelo 3" },
        ]

        this.escolherModelo = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "Escolher...",
            dataSource: modelos,
            valueExpr: "id",
            displayExpr: "descricao"
        }
    }


    // componentDidMount() {
    //     if (this.props.match.params.id !== undefined) {
    //         this.arrecadacaoDs.byKey(this.props.match.params.id)
    //             .then(data => {
    //                 if (data == undefined) {
    //                     notify("Arrecadação não encontrada.", "error");
    //                     this.props.history.push("/home");
    //                 }
    //                 this.setState(data);
    //             })
    //             .catch(erro => {
    //                 notify(erro, "error");
    //                 this.props.history.goBack();
    //             });

    //     }
    // }

    render() {
        return (
            <Popup
                visible={true}
                dragEnabled={false}
                closeOnOutsideClick={true}
                showTitle={true}
                width={'80%'}
                height={'80%'}
                title="Imóveis Inativos">
                <div className={'content-block dx-card responsive-paddings'}>
                    <Form formData={this.state} colCount={2}>
                        <GroupItem colSpan={2} colCount={2}>
                            <SimpleItem
                                dataField={'dataPagamento'}
                                editorType={'dxCheckBox'}>
                                <Label text="Data de Pagamento" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'dataDeposito'}
                                editorType={'dxCheckBox'}>
                                <Label text="Data de Depósito" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'dataInicial'}
                                editorType={'dxDateBox'}
                                editorOptions={{ width: '100%' }}>
                            </SimpleItem>
                            <SimpleItem
                                dataField={'dataFinal'}
                                editorType={'dxDateBox'}
                                editorOptions={{ width: '100%' }}>
                            </SimpleItem>
                            <SimpleItem
                                dataField={'agenteRecebedor'}
                                editorType={'dxLookup'}
                                editorOptions={this.agenteRecebedorOptions}
                                colSpan={2}>
                                <Label text="Agente Recebedor" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'modelo'}
                                editorType={'dxLookup'}
                                editorOptions={this.escolherModelo}
                                colSpan={2}>
                                <Label text="Modelo" />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <br></br>
                    <Form>
                        <GroupItem colCount={6}>
                            <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "success", text: "Salvar", onClick: this.ok }} />
                            <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "warn", text: "Cancelar", onClick: this.cancel }} />
                        </GroupItem>
                    </Form>
                </div>
            </Popup>
        );
    }
    ok() {
        notify("OK");

    }

    cancel() {
        notify("Cancelado", "warning");
        this.props.history.goBack();
    }
}
